<div class="select_order_container">
  <div class="c-pointer f-right" (click)="dismiss()">
    <img [src]="images.CROSS_ICON_STAFF" class="modal-close" alt="close" />
  </div>

  <!-- Ordertype choose  -->
  <ng-container *ngIf="modalState.orderDetails">
    <div class="m-t-10">
      <p class="modal-title">{{ 'POS.ORDER_TYPE' | fallbackTranslate }}</p>
      <p class="modal-subtitle">
        {{ 'POS.PLEASE_SELECT_ORDER_TYPE' | fallbackTranslate }}
      </p>
    </div>
    <hr class="hr-line" />
    <div class="m-t-10 m-b-10">
      <p class="modal-title">{{ 'POS.SELECT_ORDER_TYPE' | fallbackTranslate }}</p>
    </div>
    <div class="order_card_container">
      <div
        class="order-card"
        *ngFor="let item of orderType"
        (click)="orderTypeClicked(item)"
      >
        <div class="flex-space-between">
          <div class="flex">
            <img
              class="order-type-img img-24 m-l-10 m-r-20 m-t-10 m-b-10"
              src="{{ item.img_src }}"
              [alt]="item.name"
            />
            <p class="order-type-text m-b-0">{{ item.name }}</p>
          </div>
          <img
            *ngIf="currentItemName == item.name"
            class="img-24"
            [src]="images.CHECKED"
            alt="checked"
          />
        </div>

        <hr class="hr-line" />
      </div>
    </div>

    <div class="m-t-30">
      <button
        class="button_fill"
        [disabled]="currentItemName == '' || currentItemName == 'Delivery'"
        (click)="proceed('order')"
      >
        {{ 'POS.CONTINUE' | fallbackTranslate }}
      </button>
    </div>
  </ng-container>

  <!-- Customer detail -->

  <ng-container *ngIf="modalState.customerDetails">
    <div class="m-t-10 mb-10">
      <div class="">
        <p class="modal-title">{{ 'POS.CUSTOMER_DETAILS' | fallbackTranslate }}</p>
        <p class="modal-subtitle">{{ 'POS.PLAESE_' | fallbackTranslate }}</p>
      </div>
    </div>
    <hr class="hr-line m-b-10" />
    <form [formGroup]="customerForm">
      <label class="title m-t-10">{{ 'POS.CUSTOMER_NAME' | fallbackTranslate }}</label>
      <div class="flex">
        <img
          class="input-icon img-16"
          [src]="images.PERSON"
          alt="person"
        />
        <input
          type="text"
          formControlName="name"
          name="name"
          id="name"
          placeholder="{{ 'POS.ENTER_NAME_HERE' | fallbackTranslate }}"
          [ngClass]="{
            'is-invalid':
              (customerForm.get('name').errors &&
                customerForm.get('name').touched) ||
              (customerForm.get('name').touched &&
                customerForm.get('name').hasError('name'))
          }"
        />
      </div>
      <p
        class="alert-text"
        *ngIf="
          customerForm.get('name').hasError('required') &&
          customerForm.get('name').touched
        "
      >
        {{ 'POS.REQUIRED' | fallbackTranslate }}
      </p>
      <label class="title m-t-10">{{ 'POS.MOBILE_NUMBER' | fallbackTranslate }}</label>
      <div class="flex_start">
        <div class="flex flex-1">
          <img
            class="input-icon img-16"
            [src]="images.PHONE_2"
            alt="phone"
          />
          <input
            type="text"
            formControlName="dial_code"
            name="dial_code"
            id="dial_code"
            placeholder="{{ 'POS.ENTER_DIAL_CODE' | fallbackTranslate }}"
          />
        </div>

        <div class="flex-4 m-l-10">
          <input
            type="text"
            formControlName="number"
            name="number"
            maxlength="13"
            id="number"
            (keypress)="onPhoneInputChanges($event)"
            placeholder="{{ 'POS.ENTER_NUMBER_HERE' | fallbackTranslate }}"
          />
          <span class="error" *ngIf="isPhoneNumLength13Chars"> {{ 'POS.CANT_EXCEED_13_DIGITS' | fallbackTranslate }}</span>
        </div>
      </div>

      <ng-container *ngIf="currentItemName == 'Others'">
        <label class="title m-t-10">{{
          'POS.PLATFORM_NAME' | fallbackTranslate
        }}</label>
        <div class="flex">
          <img
            class="input-icon img-16"
            [src]="images.OTHER_PLATEFORM"
            alt="other-plateform"
          />
          <input
            type="text"
            name="platform"
            id="platform"
            placeholder="Enter Ordering Platform Name"
          />
        </div>
      </ng-container>
    </form>
    <div class="m-t-100"></div>

    <div class="m-t-30">
      <button
      class="button_fill"
      (click)="proceed('customer')"
    >
      {{ getButtonLabel() | fallbackTranslate }}
    </button>
    </div>
  </ng-container>

  <!-- table details -->

  <ng-container *ngIf="modalState.tableDetails">
    <div class="m-t-10 mb-10">
      <p class="modal-title">{{ 'POS.TABLE_NUMBER' | fallbackTranslate }}</p>
      <p class="modal-subtitle">
        {{ 'POS.PLEASE_SELECT_A_TABLE_NUMBER' | fallbackTranslate }}
      </p>
    </div>
    <hr class="hr-line" />
    <div *ngIf="!tableLoader">
      <nz-select [(ngModel)]="selectedSection" class="section-dropdown" (ngModelChange)="change($event)" nzSize="large">
        <nz-option *ngFor="let section of allSections" [nzValue]="section.floor_id"
          (click)="changeFloor(section.floor_id, section.floor_name)" [nzLabel]="section.floor_name | titlecase">
        </nz-option>
      </nz-select>
      <div class="table-container">
        <div
          class="table-card"
          *ngFor="let item of selectedFloorTables"
          (click)="tableClicked(item)"
        >
          <div class="flex-space-between">
            <div class="flex">
              <img
                class="order-type-img img-24 m-l-10 m-r-20 m-t-10 m-b-10"
                [src]="images.DINNING_ROOM"
                alt="dinning-room"
              />
              <p class="order-type-text m-b-0">{{ item.table_no }}</p>
            </div>
            <img
              *ngIf="currentTableId == item.table_id"
              class="img-24"
              [src]="images.CHECKED"
              alt="checked"
            />
          </div>

          <hr class="hr-line" />
        </div>
      </div>
    </div>
    <div *ngIf="tableLoader" class="dot-loader"></div>

    <div class="m-t-30">
      <button
        class="button_fill"
        [disabled]="currentTableId == ''"
        (click)="proceed('table')"
      >
        {{ 'POS.CONTINUE' | fallbackTranslate }}
      </button>
    </div>
  </ng-container>
</div>
